import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: []
})
export class HelpComponent {
  constructor(private titleService: Title) {
    this.titleService.setTitle('ProduceIT - Help');
  }
}
